import {CommercialItemDiscount, CompetitorRegistrationResultDto, ManageCompetitorErrorCodes, WspayForm} from "@model";

export class RaceRegistrationResultDto {
  totalAmount?: number;
  totalAmountWithDiscount?: number;
  traceyFeeAmount?: number;
  currencyCode?: string;
  raceRegResult?: RaceRegResult;
  wsPayForm?: WspayForm;
  bankTransferInfo?: BankTransferInfoDTO;
  competitors?: CompetitorRegistrationResultDto[];
  assignStartNumberResults?: AssignStartNumberResult[];
  endDateForPayment?: Date;
  //used for team registration
  teamCommercialItemWithDiscount?: CommercialItemDiscount;
}

class BankTransferInfoDTO {
  barcodePaymentDTO?: BarcodePaymentDTO;
  barcode?: string;
}

class BarcodePaymentDTO {
  amount?: number;
  payer?: PaymentEntityDTO;
  payeeReferenceNumber?: string;
  paymentDescription?: string;
  payeeIban?: string;
  payeeModel?: string;
  payee?: PaymentEntityDTO;
}

class PaymentEntityDTO {
  name?: string;
  address?: string;
  postalCode?: string;
  city?: string;
  country?: string
}

export enum RaceRegResult {
  OK = "OK",
  COMPETITOR_REG_NOT_OK = "COMPETITOR_REG_NOT_OK",
  FORM_VALIDATION_ERROR = "FORM_VALIDATION_ERROR",
  RACE_REGISTRATION_PERIOD_CLOSED = "RACE_REGISTRATION_PERIOD_CLOSED",
  RACE_NOT_FOUND = "RACE_NOT_FOUND"
}

export class AssignStartNumberResult {
  error?: ManageCompetitorErrorCodes;
  competitorId?: number;
  startNumber?: string;
}
